// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "border-module--base-text-alt--global--f2b99";
export var baseTextGlobal = "border-module--base-text--global--55778";
export var blockSpacing100 = "border-module--block-spacing-100--4f37c";
export var blockSpacing50 = "border-module--block-spacing-50--6064f";
export var blockVPadding100 = "border-module--block-v-padding-100--a8604";
export var blockVPadding50 = "border-module--block-v-padding-50--be75f";
export var border = "border-module--border--fbd3b";
export var captionTextGlobal = "border-module--caption-text--global--db8b6";
export var cmsRenderedContentGlobal = "border-module--cms-rendered-content--global--d8e8c";
export var defaultHSpacingGlobal = "border-module--default-h-spacing--global--f91f7";
export var fadeInAnimation = "border-module--fadeInAnimation--52496";
export var fadeInOnLoadGlobal = "border-module--fade-in-on-load--global--c6f42";
export var fullHeightGlobal = "border-module--full-height--global--ff456";
export var fullHeightOmittingNavGlobal = "border-module--full-height-omitting-nav--global--b56fd";
export var headingTextGlobal = "border-module--heading-text--global--93120";
export var ingressTextGlobal = "border-module--ingress-text--global--a2067";
export var linkColorChangeTransitionGlobal = "border-module--link-color-change-transition--global--d6e7b";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "border-module--page-heading-text--global--c1f21";
export var paragraphTextGlobal = "border-module--paragraph-text--global--835a7";
export var subheadingTextGlobal = "border-module--subheading-text--global--3b900";